import { useState } from 'react';
import Button from '../../components/common/Button';
import Icon from '../../components/common/Icon';
import './Plans.css';

const PLANS = [
  {
    id: 'free',
    name: 'Free Trial',
    price: 0,
    period: 'forever',
    description: 'Perfect for testing',
    features: [
      '100 MAU',
      'Email/Password Auth',
      'Basic Analytics',
      'Community Support'
    ],
    current: false
  },
  {
    id: 'starter',
    name: 'Starter',
    price: 99,
    period: 'month',
    description: 'For small teams',
    features: [
      '1,000 MAU',
      'Social Login',
      'MFA Support',
      'Email Support',
      'Custom Branding'
    ],
    current: false
  },
  {
    id: 'pro',
    name: 'Pro',
    price: 299,
    period: 'month',
    description: 'For growing businesses',
    features: [
      '10,000 MAU',
      'All Auth Methods',
      'Advanced Analytics',
      'Priority Support',
      'Webhooks & APIs',
      'SSO Support'
    ],
    popular: true,
    current: false
  },
  {
    id: 'enterprise',
    name: 'Enterprise',
    price: 999,
    period: 'month',
    description: 'For large organizations',
    features: [
      'Unlimited MAU',
      'Everything in Pro',
      'Dedicated Support',
      'Custom SLA',
      'On-premise Option',
      'Advanced Security',
      'Custom Integrations'
    ],
    current: true
  }
];

const Plans = () => {
  const [billingPeriod, setBillingPeriod] = useState('monthly');

  return (
    <div className="plans-page">
      <div className="page-header">
        <div>
          <h1 className="page-title">Plans & Pricing</h1>
          <p className="page-subtitle">Manage subscription plans and pricing tiers</p>
        </div>
        <div className="page-actions">
          <Button variant="secondary" icon="edit">Edit Plans</Button>
          <Button variant="primary" icon="plus">Create Plan</Button>
        </div>
      </div>

      {/* Billing Toggle */}
      <div className="billing-toggle">
        <button
          className={`toggle-btn ${billingPeriod === 'monthly' ? 'active' : ''}`}
          onClick={() => setBillingPeriod('monthly')}
        >
          Monthly
        </button>
        <button
          className={`toggle-btn ${billingPeriod === 'yearly' ? 'active' : ''}`}
          onClick={() => setBillingPeriod('yearly')}
        >
          Yearly
          <span className="save-badge">Save 20%</span>
        </button>
      </div>

      {/* Plans Grid */}
      <div className="plans-grid">
        {PLANS.map((plan) => (
          <div
            key={plan.id}
            className={`plan-card ${plan.popular ? 'popular' : ''} ${plan.current ? 'current' : ''}`}
          >
            {plan.popular && <div className="popular-badge">Most Popular</div>}
            {plan.current && <div className="current-badge">Current Plan</div>}

            <div className="plan-header">
              <h3 className="plan-name">{plan.name}</h3>
              <p className="plan-description">{plan.description}</p>
            </div>

            <div className="plan-price">
              <span className="price-amount">
                ${billingPeriod === 'yearly' ? Math.round(plan.price * 0.8) : plan.price}
              </span>
              <span className="price-period">
                {plan.price === 0 ? '' : `/${billingPeriod === 'yearly' ? 'month, billed yearly' : 'month'}`}
              </span>
            </div>

            <ul className="plan-features">
              {plan.features.map((feature, index) => (
                <li key={index}>
                  <Icon name="check" size="sm" />
                  {feature}
                </li>
              ))}
            </ul>

            <div className="plan-action">
              {plan.current ? (
                <Button variant="secondary" disabled>Current Plan</Button>
              ) : (
                <Button variant={plan.popular ? 'primary' : 'secondary'}>
                  {plan.price === 0 ? 'Start Free' : 'Upgrade'}
                </Button>
              )}
            </div>
          </div>
        ))}
      </div>

      {/* Usage Stats */}
      <section className="section">
        <div className="section-header">
          <h3 className="section-title">Plan Distribution</h3>
        </div>

        <div className="plan-stats">
          <div className="plan-stat-card">
            <div className="plan-stat-icon free">
              <Icon name="user" />
            </div>
            <div className="plan-stat-info">
              <div className="plan-stat-value">99</div>
              <div className="plan-stat-label">Free Trial</div>
            </div>
          </div>
          <div className="plan-stat-card">
            <div className="plan-stat-icon starter">
              <Icon name="users" />
            </div>
            <div className="plan-stat-info">
              <div className="plan-stat-value">59</div>
              <div className="plan-stat-label">Starter</div>
            </div>
          </div>
          <div className="plan-stat-card">
            <div className="plan-stat-icon pro">
              <Icon name="zap" />
            </div>
            <div className="plan-stat-info">
              <div className="plan-stat-value">42</div>
              <div className="plan-stat-label">Pro</div>
            </div>
          </div>
          <div className="plan-stat-card">
            <div className="plan-stat-icon enterprise">
              <Icon name="building" />
            </div>
            <div className="plan-stat-info">
              <div className="plan-stat-value">47</div>
              <div className="plan-stat-label">Enterprise</div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Plans;
